export default function log ({ next, to }) {
  // code here
  return next()
}
